import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    wordBreak: 'break-word',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
    },
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    padding: 32,
    gap: 32,
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    maxWidth: 464,
    [theme.breakpoints.up('sm')]: {
      maxHeight: 568,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 24,
  },
  inputContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    alignItems: 'center',
  },
  continueButton: {
    width: '100%',
    backgroundColor: theme.palette.primary.dark,
  },
  newCodeButton: {
    color: theme.palette.primary.dark,
    borderColor: theme.palette.primary.dark,
  },
  bottomPageContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 24,
  },
  bottomPage: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  backButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
  },
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 32,
  },
  hint: {
    width: '100%',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    width: '100%',
  },
}))
